import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_DASHBOARD_DATA,
  GET_SUBJECT_TEST_COMPLETED_DETAILS,
  GET_SUBJECT_ACTIVE_RECALL_COMPLETED_DETAILS,
  GET_SUBJECT_ADAPTIVE_LEARNING_COMPLETED_DETAILS,
  GET_SUBJECT_QUIZ_COMPLETED_DETAILS,
  GET_COURSE_DASHBOARD_OVERVIEW,
  GET_COURSE_DASHBOARD_ANALYTICS,
  GET_SUBJECT_DASHBOARD_OVERVIEW,
  GET_SUBJECT_DASHBOARD_ANALYTICS,
  GET_TOPIC_DASHBOARD_OVERVIEW,
  GET_TOPIC_DASHBOARD_ANALYTICS,
  GET_SUBTOPIC_DASHBOARD_OVERVIEW,
  GET_SUBTOPIC_DASHBOARD_ANALYTICS,
} from "../apiurls/apiurls";

export const getDashboardData = async () => {
  try {
    const response = await axiosInstance.get(GET_DASHBOARD_DATA);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const getDashboardOverview = async () => {
  try {
    const response = await axiosInstance.get(GET_COURSE_DASHBOARD_OVERVIEW);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard overview:", error);
    throw error;
  }
};

export const getDashboardAnalytics = async () => {
  try {
    const response = await axiosInstance.get(GET_COURSE_DASHBOARD_ANALYTICS);
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard analytics:", error);
    throw error;
  }
};

export const getSubjectQuizCompletedDetails = async (params) => {
  try {
    const response = await axiosInstance.get(
      GET_SUBJECT_QUIZ_COMPLETED_DETAILS,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subject quiz completed details:", error);
    throw error;
  }
};

export const getSubjectTestCompletedDetails = async (params) => {
  try {
    const response = await axiosInstance.get(
      GET_SUBJECT_TEST_COMPLETED_DETAILS,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subject test completed details:", error);
    throw error;
  }
};

export const getSubjectActiveRecallCompletedDetails = async (params) => {
  try {
    const response = await axiosInstance.get(
      GET_SUBJECT_ACTIVE_RECALL_COMPLETED_DETAILS,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching subject active recall completed details:",
      error,
    );
    throw error;
  }
};

export const getSubjectAdaptiveLearningCompletedDetails = async (params) => {
  try {
    const response = await axiosInstance.get(
      GET_SUBJECT_ADAPTIVE_LEARNING_COMPLETED_DETAILS,
      { params },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching subject adaptive learning completed details:",
      error,
    );
    throw error;
  }
};

export const getSubjectDashboardOverview = async (params) => {
  try {
    const response = await axiosInstance.get(GET_SUBJECT_DASHBOARD_OVERVIEW, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subject dashboard overview:", error);
    throw error;
  }
};

export const getSubjectDashboardAnalytics = async (params) => {
  try {
    const response = await axiosInstance.get(GET_SUBJECT_DASHBOARD_ANALYTICS, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subject dashboard analytics:", error);
    throw error;
  }
};

export const getTopicDashboardOverview = async (params) => {
  try {
    const response = await axiosInstance.get(GET_TOPIC_DASHBOARD_OVERVIEW, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching topic dashboard overview:", error);
    throw error;
  }
};

export const getTopicDashboardAnalytics = async (params) => {
  try {
    const response = await axiosInstance.get(GET_TOPIC_DASHBOARD_ANALYTICS, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching topic dashboard analytics:", error);
    throw error;
  }
};

export const getSubtopicDashboardOverview = async (params) => {
  try {
    const response = await axiosInstance.get(GET_SUBTOPIC_DASHBOARD_OVERVIEW, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic dashboard overview:", error);
    throw error;
  }
};

export const getSubtopicDashboardAnalytics = async (params) => {
  try {
    const response = await axiosInstance.get(GET_SUBTOPIC_DASHBOARD_ANALYTICS, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching subtopic dashboard analytics:", error);
    throw error;
  }
};
